import { render, staticRenderFns } from "./SalaryComparationTable.vue?vue&type=template&id=33d43f79"
import script from "./SalaryComparationTable.vue?vue&type=script&lang=js"
export * from "./SalaryComparationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports